// Регулярка для старой сигнатуры запросов
// Сигнатура слишком запутанная и вводит в недуомение, имя метода передается в объекте запроса в поле "method"
//        match index:      1        2                   3
//        example         site . /namespace  /          v1           /?
// 1. Имя сервиса (например booker)
// 2. namespace (например service)
// 3. version (например v1 или cybersport-v1 или some-stuff-v123)
// Пример:
// booker./events/v1
const oldNamespaceRx = /^(\w+)\.(\/[\w|/]+)\/([A-Za-z-]{0,15}v\d+)\/?$/i;

// Регулярка для новой сигнатуры запросов
// Сигнатура выглядит более привычно
//        match index:          1                 2                    3
//        example          /namespace /      version-v1       / some/method/name
// 1. namespace (например service)
// 2. version (например v1 или cybersport-v1 или some-stuff-v123)
// 3. method (например eventsList или documents/get или some/submethod/name)
// Пример:
// /events/v1/eventList
const newNamespaceRx = /^(\/[\w]+)\/([A-Za-z-]{0,15}v\d+)\/([\w/\d]+[^/])\/?$/i;

const cookieSet = {};

export const getCookieByName = (rawCookieString, name) => {
    const parts = `; ${rawCookieString}`.split(`; ${name}=`);

    if(parts.length > 0) {
        return parts.pop().split(';')
            .shift();
    }
};

export const getServerCookieByName = (req = {}, name) => {
    if(typeof req.cookies === 'string') {
        return getCookieByName(req.cookies, name);
    } else {
        return req.cookies[name];
    }
};

export const getClientCookieByName = (name) => {
    return getCookieByName(document.cookie, name);
};

export const setServerCookieByName = (res, name, value, expireTimestamp) => {
    const expiresDate = expireTimestamp ? (new Date(parseInt(expireTimestamp, 10) * 1000)) : null;

    if(!res.finished && !cookieSet[name]) { // не ставим куку с заданным именем больше одного раза за серверный запрос
        res.cookie(name, value, { expires: expiresDate ? expiresDate : 0, path: '/' });
        cookieSet[name] = true;
    }
};

export const setClientCookieByName = (name, value, expireTimestamp) => {
    const expiresDate = expireTimestamp ? (new Date(parseInt(expireTimestamp, 10) * 1000)) : null;
    let cookieValue = `${name}=${value};`;

    if(expiresDate) {
        cookieValue += `expires=${expiresDate.toGMTString()};`
    }
    document.cookie = `${cookieValue} path=/;`;
};

export const parseOldRequestString = (requestString) => {
    const match = requestString.match(oldNamespaceRx);

    if(!match) {
        throw new Error('Invalid request string');
    }
    const [_, serviceName, namespace, version] = match || []; // eslint-disable-line no-unused-vars

    return {
        serviceName,
        namespace,
        version
    }
};

export const parseNewRequestString = (requestString) => {
    const match = requestString.match(newNamespaceRx);

    if(!match) {
        throw new Error('Invalid request string');
    }

    const [_, namespace, version, method] = match; // eslint-disable-line no-unused-vars

    return {
        namespace,
        version,
        method
    };
};

export default {
    getCookieByName,
    getServerCookieByName,
    getClientCookieByName,
    setClientCookieByName,
    setServerCookieByName,
    parseOldRequestString,
    parseNewRequestString
};



// WEBPACK FOOTER //
// ./node_modules/core-ui__transport/helpers.js